import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp({ whatsapp = "[WHATSAPP NUMBER]" }) {
  const digits = (whatsapp || "").replace(/[^0-9]/g, "");
  const href = digits ? `https://wa.me/${digits}` : "#contact";
  const target = digits ? "_blank" : undefined;
  return (
    <a
      data-testid="floating-whatsapp"
      href={href}
      target={target}
      rel={digits ? "noreferrer" : undefined}
      aria-label="Chat on WhatsApp"
      className="fixed bottom-20 right-5 z-40 md:hidden bg-[#2C392F] text-[#F7F5F0] rounded-full p-4 shadow-lg hover:bg-[#1E2823] transition-all"
    >
      <MessageCircle size={22} />
    </a>
  );
}
